var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectionFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m225 99.984c-13.828 0-24.984 11.203-24.984 24.984 0 13.828 11.203 24.984 24.984 24.984h99.984c27.891 0 50.016 22.078 50.016 50.016v150h-249.98c-13.828 0-24.984 11.203-24.984 24.984v450c0 13.828 11.203 24.984 24.984 24.984h249.98v174.98c0 14.109-10.875 24.984-24.984 24.984h-125.02c-13.828 0-24.984 11.203-24.984 24.984 0 13.828 11.203 24.984 24.984 24.984h125.02c19.172 0 36.703-7.4062 50.016-19.453 13.312 12 30.844 19.453 50.016 19.453h125.02c13.828 0 24.984-11.203 24.984-24.984 0-13.828-11.203-24.984-24.984-24.984h-125.02c-14.109 0-24.984-10.875-24.984-24.984v-174.98h650.02c13.828 0 24.984-11.203 24.984-24.984v-450c0-13.828-11.203-24.984-24.984-24.984h-650.02v-150c0-27.891 22.078-50.016 50.016-50.016h99.984c13.828 0 24.984-11.203 24.984-24.984 0-13.828-11.203-24.984-24.984-24.984h-99.984c-29.812 0-56.625 13.359-75 34.266-18.375-20.906-45.188-34.266-75-34.266z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionFile);
export default __webpack_public_path__ + "static/media/selection-file.d1bdbf88f589d1caa35d801608444904.svg";
export { ForwardRef as ReactComponent };